import { createAction } from 'redux-actions';

const SET_EDIT_MODE_BANK = 'SET_EDIT_MODE_BANK';

export default function editModeBank(
  state = {
    editModeFlag: false,
  },
  { payload, type }
) {
  switch (type) {
    case `${SET_EDIT_MODE_BANK}_FULFILLED`:
      return {
        ...state,
        editModeFlag: payload,
      };
    default:
      return state;
  }
}

export const setEditMode = (flag) => {
  return (dispatch) => {
    const action = createAction(`${SET_EDIT_MODE_BANK}_FULFILLED`)(flag);
    dispatch(action);
  };
};
